module.exports = __webpack_public_path__ + "img/welcomelanding_icon5.05095d88.png";